import { sortingTimeSpanFn } from "layouts/views/common/common";
import { sortingDateTimeFn } from "layouts/views/common/common";

export const salesDashboardColumns = [
  {
    accessorKey: "custOrdNbr",
    header: "Customer Order Number",
    align: "left",
  },
  {
    accessorKey: "customerCode",
    header: "Customer Code",
    align: "left",
  },
  {
    accessorKey: "orderNumber",
    header: "Order Number",
    align: "left",
  },
  {
    accessorKey: "orderDateStr",
    header: "Order Date",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
  {
    accessorKey: "receivedOnStr",
    header: "Received On",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
  {
    accessorKey: "marketplace",
    header: "Marketplace",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
  {
    accessorKey: "pendingSince",
    header: "Pending Since",
    align: "left",
    sortingFn: sortingTimeSpanFn,
  },
  {
    accessorKey: "shipCompany",
    header: "Ship Company",
    align: "left",
  },
  {
    accessorKey: "shippingZone",
    header: "Shipping Zone",
    align: "left",
  },
];

export const pickedQtyColumns = [
  ...salesDashboardColumns,
  {
    accessorKey: "pickQtyStr",
    header: "Pick Quantity",
    align: "right",
  },
];

export const orderQtyColumns = [
  ...salesDashboardColumns,
  {
    accessorKey: "orderQuantityStr",
    header: "Order Quantity",
    align: "right",
  },
]

export const pickDOColumns = [
  ...pickedQtyColumns,
  {
    accessorKey: "doNumber",
    header: "DO Number",
    align: "left",
  },
]

export const pickDOManifestColumns = [
  ...pickDOColumns,
  {
    accessorKey: "manifestNumber",
    header: "Truck Manifest Number",
    align: "left",
  },
]

export const pickDOWithCancelColumns = [
  ...pickDOColumns,
  {
    accessorKey: "shipmentCancelDateStr",
    header: "Shipment Cancel Date",
    align: "left",
  },
]

export const pickDOManifestWithCancelColumns = [
  ...pickDOManifestColumns,
  {
    accessorKey: "shipmentCancelDateStr",
    header: "Shipment Cancel Date",
    align: "left",
  },
]

export const allColumns = [
  {
    accessorKey: "custOrdNbr",
    header: "Customer Order Number",
    align: "left",
  },
  {
    accessorKey: "customerCode",
    header: "Customer Code",
    align: "left",
  },
  {
    accessorKey: "orderNumber",
    header: "Order Number",
    align: "left",
  },
  {
    accessorKey: "referenceNo",
    header: "Reference No",
    align: "left",
  },
  {
    accessorKey: "status",
    header: "Status",
    align: "left",
  },
  {
    accessorKey: "orderDateStr",
    header: "Order Date",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
  {
    accessorKey: "receivedOnStr",
    header: "Received On",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
  {
    accessorKey: "pendingSince",
    header: "Pending Since",
    align: "left",
    sortingFn: sortingTimeSpanFn,
  },
  {
    accessorKey: "shipCompany",
    header: "Ship Company",
    align: "left",
  },
  {
    accessorKey: "shippingZone",
    header: "Shipping Zone",
    align: "left",
  },
  {
    accessorKey: "orderQuantityStr",
    header: "Order Quantity",
    align: "right",
  },
  {
    accessorKey: "pickQtyStr",
    header: "Pick Quantity",
    align: "right",
  },
  {
    accessorKey: "doNumber",
    header: "DO Number",
    align: "left",
  },
  {
    accessorKey: "manifestNumber",
    header: "Truck Manifest Number",
    align: "left",
  },
  {
    accessorKey: "shipmentCancelDateStr",
    header: "Shipment Cancel Date",
    align: "left",
  },
]